<template>
	<div class="Reset account-pages my-5 pt-sm-5">
		<div class="container">
			<div
				class="row justify-content-center text-fix"
				style="opacity: 0.92"
				id="login-form"
			>
				<div class="col-md-8 col-lg-6 col-xl-5">
					<div class="card overflow-hidden">
						<div
							class="text-white"
							style="
								font-family: HeaderCustomFont;
								background-color: #526635 !important;
							"
						>
							<div class="row">
								<div class="col-12">
									<div class="p-4">
										<h6 class="text-uppercase text-dark font-size-15">
											Speke Holidays Uganda
										</h6>
										<h3>Speke Management System</h3>
										<p class="text-dark font-size-18">Reset Password:</p>
									</div>
								</div>
							</div>
						</div>
						<div class="card-body pt-0">
							<div class="auth-logo">
								<a href="/" class="auth-logo-dark">
									<div class="avatar-md profile-user-wid mb-1">
										<span class="avatar-title rounded-circle bg-light">
											<img
												src="images/logo-sm.png"
												alt=""
												class="rounded-circle"
												width="34"
											/>
										</span>
									</div>
								</a>

								<!-- <a href="/" class="auth-logo-dark"> </a> -->
							</div>
							<div class="p-2">
								<form
									class="form-horizontal text-dark font-size-14"
									@submit.prevent
								>
									<div class="mb-3">
										<label for="username" class="form-label"
											>Enter Your Email</label
										>
										<input
											type="text"
											class="form-control text-dark"
											id="UserEMailAddress"
											v-model="resetPass.UserEMailAddress"
											placeholder="Enter Email"
											:class="{
												'is-invalid': resetPass.errors.has('UserEMailAddress'),
											}"
										/>
										<div
											class="invalid-feedback is-invalid"
											:form="resetPass"
											field="UserEMailAddress"
											v-html="resetPass.errors.get('UserEMailAddress')"
										/>
									</div>
									<div class="mb-3">
										<label for="username" class="form-label">OTP Code</label>
										<input
											type="text"
											class="form-control text-dark"
											id="token"
											v-model="resetPass.token"
											placeholder="Enter Email"
											:class="{
												'is-invalid': resetPass.errors.has('token'),
											}"
										/>
										<v-otp-input
											class="text-center rounded-0 d-none"
										></v-otp-input>
										<div
											class="invalid-feedback is-invalid"
											:form="resetPass"
											field="token"
											v-html="resetPass.errors.get('token')"
										/>
									</div>
									<div class="row">
										<div class="mb-3 col-md-6">
											<label class="form-label">Password</label>
											<div class="input-group auth-pass-inputgroup">
												<input
													type="password"
													id="Password"
													v-model="resetPass.Password"
													class="form-control text-dark"
													placeholder="Enter Password"
													aria-label="password"
													aria-describedby="password-addon"
													:class="{
														'is-invalid': resetPass.errors.has('Password'),
													}"
												/>
												<div
													class="invalid-feedback is-invalid"
													:form="resetPass"
													field="Password"
													v-html="resetPass.errors.get('Password')"
												/>
											</div>
										</div>
										<div class="mb-5 col-md-6">
											<label class="form-label">Confirm Password</label>
											<div class="input-group auth-pass-inputgroup">
												<input
													type="password"
													id="ConfirmPassword"
													v-model="resetPass.ConfirmPassword"
													class="form-control text-dark"
													placeholder="Confirm Password"
													aria-label="password_confirmation"
													aria-describedby="password-addon"
													:class="{
														'is-invalid':
															resetPass.errors.has('ConfirmPassword'),
													}"
												/>
												<div
													class="invalid-feedback is-invalid"
													:form="resetPass"
													field="ConfirmPassword"
													v-html="resetPass.errors.get('ConfirmPassword')"
												/>
											</div>
										</div>
									</div>

									<div
										class="modal-footer justify-content-start"
										style="font-family: HeaderCustomFont; margin-top: 50px"
									>
										<button
											type="button"
											@click="verifyPin()"
											class="btn text-white border-0"
											style="background-color: #526635 !important"
										>
											Reset Password
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- end account-pages -->
</template>



<script >
// Layout Components
// import ResetLayout from "../components/ResetLayout.vue";

// Form Components
import { Form } from "vform";
import axios from "axios";
axios.defaults.withCredentials = true;

import cookie from "js-cookie";
import config from "../config/settings.js";

// Plugins:

export default {
	name: "Reset",

	data() {
		return {
			api: config.API_URL,
			message: "",
			user: [],
			http_code: "",
			errors: [],
			resetPass: new Form({
				UserEMailAddress: "",
				token: "",
				Password: "",
				password_confirmation: "",
			}),
		};
	},
	methods: {
		cacheUser() {
			this.$router.push("/dash");
		},
		getCookie() {
			let token = cookie.get("XSRF-TOKEN");
			if (token) {
				return new Promise((resolve) => {
					resolve(token);
				});
			} else {
				return axios.get(this.api + "/csrf-cookie");
			}
		},
		resetPassword() {
			this.getCookie().then(() => {
				this.resetPass
					.post(this.api + "/reset")
					.then((response) => {
						this.message = response.data.message;

						this.$swal({
							text: this.message,
							icon: "success",
							position: "top-end",
							background: "#52BE80",
						});

						// this.$Progress.finish();
						this.resetPass.reset();
						this.$router.push("/");
					})
					.catch((error) => {
						this.message = error.response.data.message;
						this.http_code = error.response.status;
						if (this.http_code == 400) {
							this.$swal({
								text: "Error " + this.http_code + ": " + this.message,
								icon: "error",
								position: "bottom-end",
								background: "#E74C3C",
							});
						} else if (this.http_code == 422) {
							this.$swal({
								text: "Error " + this.http_code + ": Invalid Information",
								icon: "error",
								position: "bottom-end",
								background: "#E74C3C",
								timer: 7500,
							});
						} else {
							this.$swal({
								text: "Error " + this.http_code + ": " + this.message,
								icon: "error",
								position: "bottom-end",
								background: "#E74C3C",
								timer: 7500,
							});
						}
					});
			});
		},
		verifyPin() {
			this.getCookie().then(() => {
				this.resetPass
					.post(this.api + "/verify/pin")
					.then((response) => {
						this.message = response.data.message;

						this.resetPassword();
					})
					.catch((error) => {
						this.message = error.response.data.message;
						this.http_code = error.response.status;

						this.$swal({
							text: "Error " + this.http_code + ": " + this.message,
							icon: "error",
							position: "bottom-end",
							background: "#E74C3C",
							timer: 7500,
						});
					});
			});
		},
	},
	created() {
		// this.$emit("update:layout", ResetLayout);
	},
	beforeMount() {},
	mounted() {},
	unmounted() {},
};
</script>

<style>
/*** EDWIN: API call with access token
axios.get('/api/endpoint', {
headers: {
	'Authorization': 'Bearer ' + yourToken
}
})
.then(response => {
	// handle success
})
.catch(error => {
	// handle error
})		 
***/
</style>
